import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import DisplayComponent from './components/DisplayComponent';
import InfoComponent from './components/InfoComponent';
import FormComponent from './components/FormComponent';
import { saveToLocalStorage, getFromLocalStorage } from './utils/localstorage';
import './App.css';

const App = () => {
  const [data, setData] = useState(null);
  const [url, setUrl] = useState('');
  const [keyword, setKeyword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isAllowedDomain = (candidateUrl) => {
    if (!candidateUrl) {
      return false;
    }
    try {
      const parsedUrl = new URL(candidateUrl);
      if (parsedUrl.protocol !== 'https:') {
        return false;
      }
      const { hostname } = parsedUrl;
      const allowedDomains = ['univ-cotedazur.fr', 'univ-cotedazur.eu'];
      return allowedDomains.some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
    } catch (error) {
      return false;
    }
  };

  useEffect(() => {
    if (url) {
      saveToLocalStorage('url', url);
    }
    if (keyword) {
      saveToLocalStorage('keyword', keyword);
    }
  }, [url, keyword]);

  useEffect(() => {
    const urlFromLocalStorage = getFromLocalStorage('url');
    const keywordFromLocalStorage = getFromLocalStorage('keyword');
    setUrl(urlFromLocalStorage ?? '');
    setKeyword(keywordFromLocalStorage ?? '');
  }, []);

const fetchData = async (cleanUrl, cleanKeyword) => {
    console.log('GO');
  
    if (isAllowedDomain(cleanUrl)) {
      setIsLoading(true);
      setData(null);
  
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          url: cleanUrl,
          keyword: cleanKeyword
        })
      };
  
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/main.php`, requestOptions);
        const jsonData = await response.json();
        setData(jsonData);
        console.log('Données récupérées:', jsonData);
        console.log('OK');
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Ce site ne peut analyser que les sites de l'Université Côte d'Azur.");
    }
  };

  return (
    <>
      <header className="text-bg-primary text-white py-3 mb-4">
        <div className="container-fluid">
          <div className="d-flex align-items-center d-flex justify-content-between">
            <a href="https://univ-cotedazur.fr" className="d-flex align-items-center me-2 text-decoration-none">
              <img src="https://univ-cotedazur.fr/medias/photo/ucalogoqlarge-inversenew_1662386550360-png" height="32" loading="lazy" style={{ filter: 'brightness(0) invert(1)' }} alt="" />
            </a>
            <ul className="nav mb-2 justify-content-center mb-md-0">
              <li><a href="https://filrouge.univ-cotedazur.fr/" className="nav-link px-2 text-white"><i className="bi bi-compass-fill"></i> Audit SEO "Fil rouge"</a></li>
              <li><a href="https://services-numeriques.univ-cotedazur.fr/tools/matomo/dashboard" className="nav-link px-2 text-white"><i className="bi bi-bar-chart-fill"></i> Analytics Sites autonomes</a></li>
              <li><a href="https://services-numeriques.univ-cotedazur.fr/tools/matomo/segment" className="nav-link px-2 text-white"><i className="bi bi-bar-chart-fill"></i> Analytics Mini-sites</a></li>
              <li><a href="https://services-numeriques.univ-cotedazur.fr/tools/matomo/qrcode" className="nav-link px-2 text-white"><i className="bi bi-qr-code-scan"></i> QRCodes campagnes</a></li>
              {/* <li><a href="https://services-numeriques.univ-cotedazur.fr/tools/matomo/ecoconception" className="nav-link px-2 text-white"><i className="bi bi-flower1"></i> Eco-conception</a></li> */}
              <div className="dropdown">
                <a className="nav-link px-2 text-white dropdown-toggle" href="#" data-bs-toggle="dropdown"><i className="bi bi-life-preserver"></i> Assistance</a>
                <ul className="dropdown-menu">
                  <li><a className="dropdown-item d-flex" href="#"><i className="bi bi-person-plus me-1"></i><span> Onboarding </span><i className="bi bi-arrow-up-right ms-auto"></i></a></li>
                  <li><a className="dropdown-item d-flex" href="https://univ-cotedazur.fr/la-fabrique-web"><i className="bi bi-lightbulb me-1"></i> La Fabrique Web <i className="bi bi-arrow-up-right ms-auto"></i></a></li>
                  <li><a className="dropdown-item d-flex" href="https://glpi.univ-cotedazur.fr/plugins/formcreator/front/formdisplay.php?id=157"><i className="bi bi-life-preserver me-1"></i><span> Demande d'assistance </span><i className="bi bi-arrow-up-right ms-auto"></i></a></li>
                  {/* <li><a className="dropdown-item d-flex" href="#"><i className="bi bi-box-arrow-right me-1"></i> Externalisation web <i className="bi bi-arrow-up-right ms-auto"></i></a></li> */}
                </ul>
              </div>
            </ul>
          </div>
        </div>
      </header>

      <div className="container-fluid">


        <div className="row mb-4">
          <div className="col-md-5 d-flex flex-column">

            <FormComponent onSubmit={fetchData} url={url} setUrl={setUrl} keyword={keyword} setKeyword={setKeyword} />


            <h1 className="mb-2 d-flex align-items-center">
              <i className="bi bi-eye-fill small me-2"></i>
              Visualisation
              <InfoComponent
                text="Vous pouvez avoir un aperçu de votre page qui vous permet de repérer les points à améliorer pour le référencement naturel de votre page."
                style={{
                  marginLeft: '0.5rem',
                  marginTop: '0.5rem'
                }}
              />
            </h1>
            {isAllowedDomain(url) ? (
              <iframe src={url} title="Website Preview" frameBorder="0" style={{ overflow: 'hidden', height: '100%', width: '100%', zoom: '0.5', minHeight: '1500px' }} className="rounded-5"></iframe>
            ) : (
              <Alert variant="danger">
                Ce site ne peut analyser que le site principal de l'Université Côte d'Azur.
              </Alert>
            )}
          </div>


          <div className="col-md-7">
            <h1 className="mb-2"><i className="bi bi-trophy-fill small"></i> Résultats d'analyses</h1>

            <DisplayComponent
              data={data}
              isLoading={isLoading}
              url={url}
              keyword={keyword}
            />
          </div>

        </div>

      </div>

      <footer className="container-fluid bg-dark text-white mt-auto">
        <section className="d-flex align-items-center py-4">
          <a href="https://univ-cotedazur.fr" className="p-0 text-decoration-none">
            <img alt="Université Côte d'Azur" src="https://univ-cotedazur.fr/medias/photo/ucalogoqlarge-inversenew_1662384375824-png" style={{ filter: 'brightness(0) invert(1)', maxHeight: '3.25em' }} loading="lazy" />
          </a>
        </section>
      </footer>

    </>
  );
};

export default App;
